import { FC, ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const THead: FC<Props> = ({ children }) => {
  return <thead className="bg-gray-50">{children}</thead>;
};
